import React from 'react'
import {InitForm} from './initForm'
export const IniciarSesion = () => {
  return (
     <InitForm />
  )
}

export default IniciarSesion
